<template>
    <aside id="popup-add-governance-rule" class="layout-popup mfp-hide" data-layout-step>
        <h2 class="layout-popup-title">
            {{ $t('POLICY.RULE.POPUP.TITLE.' + (isEdit ? 'EDIT' : isCopy ? 'COPY': 'ADD')) }}
        </h2>
        <div v-show="!isEdit && !isCopy" style="text-align: right;">
            <label for="toggleButton">Auto assessment
            <toggle-button
                id="toggleButton"
                :labels="{checked: 'Auto', unchecked: 'Manual'}"
                v-model="autoAssessmentToggle"
                @change="changeToggle"
            />
            </label>
        </div>
        <div v-if="isRenderPopup">
            <div v-if="rule.autoExeYn=='Y' || rule.autoExeYn==null">
                <auto-rule-popup
                    :isFirstLoad="isFirstLoad"
                    :callLoading="callLoading"
                    :rule="rule"
                    :newTmplt="newTmplt"
                    :isEdit="isEdit"
                    :isCopy="isCopy"
                    :categoryList="categoryList"
                    :tmpltList="templateList"
                    :actionTemplateList="actionTemplateList"
                    :userList="userList"
                    :saveRule="saveRule"
                    :actionListBySelectedTemplate="actionListBySelectedTemplate"
                    :setActionList="setActionList"
                />
            </div>
            <div v-else>
                <manual-rule-popup
                    :isFirstLoad="isFirstLoad"
                    :callLoading="callLoading"
                    :rule="rule"
                    :isEdit="isEdit"
                    :isCopy="isCopy"
                    :categoryList="categoryList"
                    :saveRule="saveRule"
                />
            </div>
        </div>
    </aside>
</template>
<script>

import { ToggleButton } from 'vue-js-toggle-button'
import AutoRulePopup from './systemAutoRulePopup.vue'
import ManualRulePopup from "./systemManualRulePopup.vue"

export default {
    name: 'RulePopup',
    components: {
        ToggleButton,
        ManualRulePopup,
        AutoRulePopup
    },
    props: {
        rule: Object,               // Popup 에서 control 될 Rule 정보
        newTmplt: Array,            // 사용되고있는 Template의 정보 리스트
        categoryList: Array,        // 회사에 등록되어있는 Category Label 정보 리스트
        actionTemplateList: Array,  // action 정보 리스트
        userList: Array,            // 회사에 가입되어있는 사용자 리스트 정보(Email 수신자 추가시 필요)
        isEdit: Boolean,            // Edit 모드 활성화 플래그
        isCopy: Boolean,            // Copy 모드 활성화 플래그
        pending: Boolean,           // Popup Saving Flag
        templateList: Array,
        insertGovernanceRule: Function,
        isRenderPopup: {
            type: Boolean,
            default: true
        },
        callLoading: Function,
        saveRule: Function,
        actionListBySelectedTemplate: Array, // Condition 으로 선택할 수 있는 Action List
        setActionList: Function,
    },
    data: function() {
        return {
            autoAssessmentToggle: true,
            isFirstLoad: true
        }
    },
    watch: {
        autoAssessmentToggle(value){
            if(value){
                this.rule.autoExeYn = 'Y'
            }else{
                this.rule.autoExeYn ='N';
            }
        }
    },
    methods: {
        changeToggle() {
            this.isFirstLoad = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/bestpractice/systemRulePopup.vue